import { Outlet, useNavigate } from 'react-router-dom';

import { ProfileDropdown } from './components/ProfileDropdown';
import Styles from './index.module.scss';
import { usePageHandle } from './MainLayout.config';

import { usePageTimeFilter } from '@/app/hooks/usePageTimeFilter';
import { ButtonLink } from '@/components/Elements/ButtonLink';
import { IconButton } from '@/components/Elements/IconButton';
import { ArrowIcon, TemplatesIcon } from '@/components/Elements/Icons';
import { SearchQueryInput } from '@/components/Elements/SearchQueryInput';
import { PeriodSelector } from '@/components/PeriodSelector';
import { OrganizationsFilter } from '@/features/Organization/filter/OrganizationsFilter';

export const MainLayout = () => {
	const [periodValue, onPeriodValueChanged] = usePageTimeFilter();
	const navigate = useNavigate();

	const {
		displayFilter,
		isChild,
		title,
		displayTimeFilter,
		displaySearchFilter,
		actions,
		toolbar,
		actionsMenu,
		variant,
	} = usePageHandle();

	const Toolbar = toolbar ?? null;
	const ActionsMenu = actionsMenu ?? null;

	return (
		<div className={Styles.container}>
			<div className={Styles.header}>
				{isChild && (
					<button
						onClick={() => {
							navigate(-1);
						}}
					>
						<ArrowIcon />
					</button>
				)}
				<h1>{title}</h1>
				<div className={Styles.filterContainer}>
					{displayFilter && <OrganizationsFilter />}
				</div>
				<ProfileDropdown />
			</div>
			<div className={Styles.subMenu}>
				{displayTimeFilter && (
					<PeriodSelector value={periodValue} onChange={onPeriodValueChanged} />
				)}
				<div className={Styles.actions}>
					{actions?.map((action) => {
						if (action.type === 'button') {
							return (
								<ButtonLink key={action.path} to={action.path}>
									{action.title}
								</ButtonLink>
							);
						}
						return (
							<IconButton key={action.path}>
								<TemplatesIcon />
							</IconButton>
						);
					})}
					{ActionsMenu && <ActionsMenu />}
				</div>
			</div>
			<div
				className={Styles.page}
				style={{ background: variant === 'transparent' ? 'transparent' : undefined }}
			>
				<div className={Styles.pageFilter}>
					{displaySearchFilter && (
						<div className={Styles.searchContainer}>
							<SearchQueryInput placeholder={`Search ...`} />
						</div>
					)}
					<div className={Styles.searchToolbarContainer}>{Toolbar && <Toolbar />}</div>
				</div>
				<div className={Styles.pageContent}>
					<Outlet />
				</div>
			</div>
		</div>
	);
};
